
import Vue from "vue";
import {clearPersistedSession} from "~/assets/utils/PersistedSession";

export default Vue.extend({
	name: 'Logout',
	methods: {
		async logout() {
			try {
				await this.$auth.logout()
			} finally {
				this.$store.dispatch('RESET_STATE')
				clearPersistedSession(this.$cookies, {
					authStorageKeys: this.$config.persistedSessionAuthStorageKeys
				})
				this.$router.push('/login')
			}
		}
	},
	watch: {
		'$route.name'() {
			this.open = false;
		}
	},
});
